import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useProjectDetail = (id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [projectInfo, setProjectInfo] = useState<ProjectInfoDto>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading } = useQuery(
    [endpoints.project.info, id],
    () =>
      fetcher.project.postProjectInfo({id: id}),
    {
      enabled: id > 0,
      onSuccess: (res: ProjectInfoResDto) => {
        switch (res.code) {
          case 200:
            setProjectInfo(res.result?.info);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: projectInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.project.add],
    fetcher.project.postProjectInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: projectUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.project.update],
    fetcher.project.postProjectUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: projectDelete, isSuccess: deleteSuccess } = useMutation(
    [endpoints.project.delete],
    fetcher.project.postProjectDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   


  return { isLoading, projectInfo, insertSuccess, updateSuccess, deleteSuccess, projectInsert, projectUpdate, projectDelete };
};

export default useProjectDetail;
